import { useEffect, useRef } from 'react';

const useInterval = (fn, deps = [], opts = {}) => {
  const interval = opts.interval || 5000;
  const overrideInterval = opts.overrideInterval || 1000;
  const skips = Math.ceil(interval / overrideInterval);
  const overrideRef = useRef(false);
  const counterRef = useRef(0);
  overrideRef.current = false;
  const pollFunction = () => {
    const counter = counterRef.current;
    counterRef.current = counter > skips ? 0 : counter + 1;
    const runFunction = counter > skips || overrideRef.current === true;
    if (runFunction) {
      fn({ first: false });
    }
  };

  useEffect(() => {
    fn({ first: true });
    const pointer = setInterval(pollFunction, overrideInterval);
    return () => clearInterval(pointer);
  }, deps);

  return { overrideRef };
};

export default useInterval;
